export const queryParamToString = (param: string | number | readonly string[] | undefined): string | undefined => {
    if (typeof param === 'string') {
        return param;
    }

    if (Array.isArray(param)) {
        return String(param[0]);
    }

    if (typeof param === 'number') {
        return String(param);
    }
};
